import { FolderTreeNode, IFolderTreeNode } from "./folderTreeNode";

export interface IDocumentFolders {
    folderTree: IFolderTreeNode;
}

export class DocumentFolders implements IDocumentFolders {
    folderTree: FolderTreeNode;

    constructor();
    constructor(obj: IDocumentFolders);
    constructor(obj?: any) {
        this.folderTree = new FolderTreeNode(obj && obj.folderTree || null);
        this.folderTree.expanded = true;
    }
}